import React from 'react';

const Clients = () => {
  const logos = [
    "/clients/university-living.png",
    "/clients/adobe.png",
    "/clients/bhel.png",
    "/clients/bureau-veritas.png",
    "/clients/cadence.png",
    "/clients/coforge.png",
    "/clients/libas.png",
    "/clients/mankind.png",
    "/clients/rockwell.png",
    "/clients/siemens.png",
    "/clients/newgen.png",
    "/clients/bigbasket.png"
  ];

  return (
    <section className="py-16 bg-zinc-950 border-t border-zinc-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 text-center">
        <h3 className="text-gold text-sm font-bold tracking-widest uppercase mb-2">Our Trusted Partners</h3>
        <h2 className="text-3xl font-bold font-serif text-white">Clients Who Trust Us</h2>
      </div>
      
      <div className="relative w-full flex overflow-hidden py-4">
        {/* Overlay gradients for a smooth fade-in/out effect at the screen edges */}
        <div className="absolute top-0 left-0 w-16 md:w-32 h-full bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-16 md:w-32 h-full bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none"></div>
        
        <div className="flex animate-infinite-scroll whitespace-nowrap w-max hover:[animation-play-state:paused]">
          {/* Render logos twice for a seamless infinite scroll loop */}
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="mx-4 md:mx-6 flex items-center justify-center h-24 w-48 md:w-64 bg-zinc-900 border border-zinc-800 rounded-lg shrink-0 group hover:border-gold transition duration-300 cursor-pointer shadow-sm p-4">
              <img 
                src={logo} 
                alt={`Client partner ${index + 1}`} 
                className="max-h-full max-w-full object-contain group-hover:grayscale-0 group-hover:opacity-100 transition duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;